// In-memory store for the OTP-verified user.
// Survives in-app (SPA) navigation but is cleared on page reload / tab close,
// since a module-level variable lives only as long as the JS context.
// NOTE: intentionally NOT localStorage/sessionStorage — those survive reloads,
// which we don't want. This is a UX convenience, not a security boundary.
let verifiedUser = null;

export const setVerifiedUser = (u) => { verifiedUser = u; };
export const getVerifiedUser = () => verifiedUser;
export const clearVerifiedUser = () => { verifiedUser = null; };
